import { PostMediaFile } from "shared/types/post";

export const GMB_MIN_IMAGE_DIMENSION = 250;
export const GMB_MIN_IMAGE_BYTES = 10_240;

function isImageFile(file: Pick<PostMediaFile, "isVideo" | "type" | "url">) {
  return (
    !file.isVideo &&
    file.type !== "document" &&
    !(file.url && file.url.includes(".pdf"))
  );
}

export function getGmbImageValidationFailure(file: PostMediaFile) {
  if (!isImageFile(file)) {
    return null;
  }

  const width = file.meta?.width;
  const height = file.meta?.height;
  const byteSize = file.meta?.byteSize;

  if (
    typeof width === "number" &&
    typeof height === "number" &&
    (width < GMB_MIN_IMAGE_DIMENSION || height < GMB_MIN_IMAGE_DIMENSION)
  ) {
    return "dimensions" as const;
  }

  if (typeof byteSize === "number" && byteSize < GMB_MIN_IMAGE_BYTES) {
    return "byteSize" as const;
  }

  return null;
}

export function isInvalidGmbImage(file: PostMediaFile) {
  return getGmbImageValidationFailure(file) !== null;
}
